import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import DetailsKV from "@eres/ejari-web/component/DetailsKV";
import { DateUtil } from "@eres/core";
import { Comment } from "../../../../apis/privatesell/enitites";
import { FormContainer } from "../Base";

interface Props {
	comments: Comment[];
}

export default class RejectionComments extends Component<Props> {
	render() {
		const comments = this.props.comments;
		return <FormContainer title={ Strings.rejection_reason }>
			<div className="flex-grid">
				{
					comments.map( comment => {
						return <>
							<DetailsKV
								label={ DateUtil.formatDate( comment.createdDate!.asDate(), "DD/MM/YYYY hh:mm:ss A", "en" ) + " : " }
								value={ comment.comment }/>
						</>;
					} )
				}
			</div>
		</FormContainer>;
	}
}
